import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { useField } from 'formik';
import APIMethodKeys from '../../../../client/APIMethodKeys';
import { GlobalContext } from '../../../contexts/GlobalContext';
import { UserContext } from '../../../contexts/UserContext';
import { DashboardContext } from '../../../scenes/DashboardScene/DashboardContext';
import { Div } from '../../helpers/StyledUtils';
import { StyledOption } from '../../Form/Fields/MultiSelectInput';
import Divider from '../../base/Divider';
import Button from '../../base/Button';
import useSWR from 'swr';
import Loading from '../../base/Loading';
import Text from '../../base/Text';
const CliUserFilter: React.FC<{
  in_dropdown?: boolean;
  onBack?: () => void;
}> = t0 => {
  const $ = _c(36);
  const {
    in_dropdown,
    onBack
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    user
  } = useContext(UserContext);
  const {
    team
  } = useContext(DashboardContext);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      name: "cli_user_id"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [, t2, t3] = useField(t1);
  const {
    value
  } = t2;
  const {
    setValue
  } = t3;
  let t4;
  if ($[1] !== team.id) {
    t4 = APIMethodKeys.teams.listMembers(team.id);
    $[1] = team.id;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== HookdeckAPI.teams) {
    t5 = () => HookdeckAPI.teams.listMembers();
    $[3] = HookdeckAPI.teams;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const {
    data: team_members,
    isValidating
  } = useSWR(t4, t5);
  let T0;
  let T1;
  let t10;
  let t11;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[5] !== in_dropdown || $[6] !== isValidating || $[7] !== onBack || $[8] !== setValue || $[9] !== team_members || $[10] !== user || $[11] !== value) {
    const options = team_members ? team_members.map(u => ({
      value: u.user_id,
      label: u.user_id === user.id ? "Myself" : u.user_name
    })) : [];
    T1 = Div;
    if ($[20] !== in_dropdown || $[21] !== onBack) {
      t11 = in_dropdown ? <><Div flex={{
          align: "center",
          gap: 3
        }} p={3}><Button outline={true} small={true} icon="arrow_back" onClick={onBack} /><Text semi={true}>Filter by CLI user</Text></Div><Divider /></> : null;
      $[20] = in_dropdown;
      $[21] = onBack;
      $[22] = t11;
    } else {
      t11 = $[22];
    }
    T0 = Div;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = {
        direction: "column"
      };
      $[23] = t6;
    } else {
      t6 = $[23];
    }
    t7 = 0;
    t8 = 1;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = {
        maxHeight: "300px",
        overflowY: "auto"
      };
      $[24] = t9;
    } else {
      t9 = $[24];
    }
    t10 = options && options?.length > 0 ? options.map(o => <StyledOption key={o.label} p={{
      x: 2,
      y: 1.5
    }} label={o.label} size="m" name={o.label} checked={value?.includes(o.value)} onChange={e => {
      setValue(e.currentTarget.checked ? [...(value || []), o.value] : (value || []).filter(v => v !== o.value));
    }} />) : isValidating ? <Div p={{
      x: 3,
      y: 3
    }} flex={{
      justify: "center"
    }}><Loading /></Div> : <Div p={{
      x: 3,
      y: 3
    }}><Text muted={true}>No options</Text></Div>;
    $[5] = in_dropdown;
    $[6] = isValidating;
    $[7] = onBack;
    $[8] = setValue;
    $[9] = team_members;
    $[10] = user;
    $[11] = value;
    $[12] = T0;
    $[13] = T1;
    $[14] = t10;
    $[15] = t11;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    T0 = $[12];
    T1 = $[13];
    t10 = $[14];
    t11 = $[15];
    t6 = $[16];
    t7 = $[17];
    t8 = $[18];
    t9 = $[19];
  }
  let t12;
  if ($[25] !== T0 || $[26] !== t10 || $[27] !== t6 || $[28] !== t7 || $[29] !== t8 || $[30] !== t9) {
    t12 = <T0 flex={t6} m={t7} p={t8} style={t9}>{t10}</T0>;
    $[25] = T0;
    $[26] = t10;
    $[27] = t6;
    $[28] = t7;
    $[29] = t8;
    $[30] = t9;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== T1 || $[33] !== t11 || $[34] !== t12) {
    t13 = <T1>{t11}{t12}</T1>;
    $[32] = T1;
    $[33] = t11;
    $[34] = t12;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  return t13;
};
export default CliUserFilter;